import common from './common.json';
import custom from './custom.json';
import { deepMerge } from '../_merge';

const translations = deepMerge(common, custom);

export default translations;
